export const Stages = {
  IDLE: "idle",
  UNLOADED: "unloaded",
  DOWNLINK: "downlink",
  UPLINK: "uplink",
  DONE: "done"
};
